import Component from 'e-submission/components/Button'
export default (hoc) => hoc(Component)
